import {
    Button,
    Modal,
    Typography,
} from "@mui/material";
import { React, useState, useEffect, useRef } from 'react'
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ModalVisualizacionPDF = ({ idcliente, onClose, open }) => {
    const fileInputRef = useRef(null);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [state, setState] = useState({
        documento: "",
        vencimiento: "",
        comentarios: "",
        extension: "",
        bdocumento: "",
        bvencimiento: "",
        bcomentarios: "",
    });

    const [titulo, setTitulo] = useState("")


    const handleButtonClick = () => {
        // Esto hace clic en el input oculto
        fileInputRef.current.click();
    };


    const Editar = () => {

        request
            .get(`ReferenciaBancaria/ReportePDF?idcliente=${idcliente}`)
            .then((result) => {

                let doc = result.documento;

                if (doc && !doc.startsWith("data:")) {
                    doc = `data:application/pdf;base64,${doc}`;
                }

                setState((prev) => ({
                    ...prev,
                    documento: doc,
                    extension: result.extension,
                }));

                setTitulo(result.nombredocumento)
            })
            .catch((error) => {
                Swal.fire("INTERESES", JSON.stringify(error), "error");
            });
    }

    useEffect(() => {
        Editar();
    }, [idcliente]);


    const GetFile = (e) => {
        const target = e.target;

        if (!target.files || target.files.length === 0) return;

        const file = target.files[0];
        const fileName = file.name;
        const extension = fileName.split(".").pop().toLowerCase();

        if (!["PDF", "pdf"].includes(extension)) {
            Swal.fire("Clientes", "Archivo con formato no válido", "error");
            target.value = "";
            return;
        }

        const fReader = new FileReader();
        fReader.readAsDataURL(file);
        fReader.onloadend = function (event) {
            setState((prev) => ({
                ...prev,
                documento: event.target.result,
                extension: extension,
            }));

            // onGuardar(event.target.result)
        };
    };

    const onGuardar = (documento) => {

        const post = {
            idrol: idcliente,
            documento: documento,
            usuario: 0
        }

        request
            .post("SimuladorIncentivos/Guardar_documento", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("POWERGARD", JSON.stringify(error), "error");
            });
    }

    const handleDownload = () => {
        if (!state.documento) {
            Swal.fire("DESCARGA", "No hay documento para descargar.", "warning");
            return;
        }

        const link = document.createElement("a");
        link.href = state.documento;
        link.download = `${titulo}.${state.extension}`;
        link.click();
    };


    const onCerrar = () => {

        onClose()
    }


    return (

        // <div className="modal-visualizar-pdf-main-container">
        //     <div className="credito-agregar-modal-title">

        //         <div className="modal-visualizar-pdf-main-titulo">
        //             <h3>{titulo} </h3>
        //         </div>
        //         <div className="modal-visualizar-pdf-buttons-actions">
        //             {/* Input oculto */}
        //             <input
        //                 type="file"
        //                 style={{ display: "none" }}
        //                 ref={fileInputRef}
        //                 onChange={GetFile}
        //             />

        //             <button
        //                 className="modal-visualizar-pdf-button-download"
        //                 onClick={() => handleDownload()}
        //             >
        //                 <FileDownloadIcon />
        //                 descargar
        //             </button>

        //             <div className="cerrar-modal-button" onClick={onClose}>X</div>
        //         </div>
        //         <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
        //             <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
        //             <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
        //             <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
        //         </div>
        //     </div>
        <div style={{ height: "85%", width: "100%", paddingLeft: 10, paddingRight:10, paddingTop: 10, paddingBottom: 10 }}>
            {state.documento ? (
                <iframe
                    src={state.documento}
                    title="Vista previa PDF"
                    width="100%"
                    height="100%"
                    style={{ border: "1px solid #ccc" }}
                />
            ) : (
                <Typography variant="body2" color="textSecondary">
                    No hay documento cargado.
                </Typography>
            )}
        </div>


    )
}

export default ModalVisualizacionPDF
